import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CMDB_CLASS_URL } from 'src/constants/urls'

export default createReducer(
    {
        cmdbClassById: {},
        cmdbClassValues: [],
        cmdbClassLoading: false,
        cmdbImportContactType: 'users',
    },
    {
        [actions.SEARCH_CMDB_CLASS]: (state) => {
            return { ...state, cmdbClassLoading: true }
        },
        [actions.SEARCH_CMDB_CLASS_SUCCESS]: (state, action) => {
            const { results } = action.payload.data
            return {
                ...state,
                cmdbClassLoading: false,
                cmdbClassById: {
                    ...results.reduce(
                        (agg, cmdbClass) => ({
                            ...agg,
                            [cmdbClass.id]: cmdbClass,
                        }),
                        {}
                    ),
                },
                cmdbClassValues: results.map((cmdbClass) => cmdbClass.id),
            }
        },
        [actions.SEARCH_CMDB_CLASS_ERROR]: (state) => ({
            ...state,
            cmdbClassLoading: false,
        }),
        [actions.SET_CMDB_IMPORT_CONTACT_TYPE]: (state, action) => ({
            ...state,
            cmdbImportContactType: action.payload.contactType,
        }),
    }
)

export const getCmdbClasses = (state) =>
    state.cmdb.misc.cmdbClassValues.map((c) => state.cmdb.misc.cmdbClassById[c])

export const searchCmdbClass = (name) => ({
    type: actions.API,
    method: 'get',
    payload: {
        url: `${CMDB_CLASS_URL}${name ? name + '/' : ''}`,
        start: () => ({ type: actions.SEARCH_CMDB_CLASS }),
        success: (payload) => ({
            type: actions.SEARCH_CMDB_CLASS_SUCCESS,
            payload,
        }),
        error: (error) => ({
            type: actions.SEARCH_CMDB_CLASS_ERROR,
            name: error.name,
            message: error.message,
        }),
    },
    debounce: {
        key: 'searchCmdbClass',
        wait: 500,
    },
})

export const setCmdbImportContactType = (contactType) => ({
    type: actions.SET_CMDB_IMPORT_CONTACT_TYPE,
    payload: {
        contactType,
    },
})
